import httpService from "./httpService";

export default {
    getAll: async () => {
        return await httpService.get('walk-distance-all');
    },
};
